import { connect } from 'react-redux';

import AccountingIndex from '../components/management/Accounting';

const Index = connect()(AccountingIndex);

export default Index;



/** WEBPACK FOOTER **
 ** ./src/containers/Accounting.js
 **/